module.exports = __webpack_public_path__ + "img/logo.b50a9f60.png";